module.exports = __webpack_public_path__ + "b729e763a0ef82e50aa22b2c87178aa5.png";